import { makeAuthService } from '../../auth/auth-service-factory';
import { makeLogService } from '../../common/log/log/log-service-factory';
import { ServiceGroupServiceImpl } from './service-group-service-impl';

export function makeServiceGroupService() {
  return new ServiceGroupServiceImpl(makeLogService(), makeAuthService());
}
